var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 0.21905582,4.900601 c 0.244078,-0.254717 0.639806,-0.254717 0.88388198,0 l 2.43306,2.539187 V 0.66554 c 0,-0.360233 0.27982,-0.652261 0.625,-0.652261 0.34518,0 0.625,0.292028 0.625,0.652261 v 6.774248 l 2.18306,-2.278284 c 0.24408,-0.254718 0.63981,-0.254718 0.88388,0 0.24408,0.254727 0.24408,0.667713 0,0.92244 l -3.25,3.39176 c -0.24407,0.2547276 -0.6398,0.2547276 -0.88388,0 L 0.21905582,5.823042 c -0.2440776,-0.254728 -0.2440776,-0.667713 0,-0.922441 z",
    fill: "#384E66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.b1534e6c6b30f05b117d09a3df8c2012.svg";
export { ForwardRef as ReactComponent };